export default __webpack_public_path__ + "static/media/des.6bfe8d50.png";